import styled from 'styled-components';
import { FlexColumn } from '@make-software/tg-mini-app-ui';

export const Container = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    marginTop: 20
  })
);
